<template>
    <template-block
        v-if="localModel"
        type="Bild"
        @toggle-collapsible="$emit('toggle-collapsible')"
        :open="open"
        @delete="$emit('delete')"
        :locked="value.locked"
        :position="value.position"
        :mode="mode"
        @update:locked="localModel.locked = $event; emitChange();"
        @update:position="localModel.position = $event; emitChange();"
    >
        <div class="form-group">
            <div class="custom-control custom-radio custom-control-inline">
                <div>Bildkälla:</div>
            </div>
            <div class="custom-control custom-radio custom-control-inline mb-2">
                <input type="radio" class="custom-control-input" :name="'use_media_bank-' + localModel.id" :id="'chk-use-mediabank-' + vid" v-model="useMediabank" :value="true" @change="changeSource">
                <label class="custom-control-label" :for="'chk-use-mediabank-' + vid">Mediabank</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline mb-2">
                <input type="radio" class="custom-control-input" :name="'use_media_bank-' + localModel.id" :id="'chk-use-url-' + vid" v-model="useMediabank" :value="false" @change="changeSource">
                <label class="custom-control-label" :for="'chk-use-url-' + vid">URL</label>
            </div>
        </div>
        <div
            v-if="useMediabank"
            style="max-width: 200px;"
        >
            <mediabank-selector
                v-model="localModel.mediaId"
                @input="emitChange"
                btn-class="btn-sm btn-secondary"
                btn-text="Välj bild från mediabank"
                btn-icon="icon-image2"
                thumbnail
                upload
            ></mediabank-selector>
        </div>

        <input-with-validation
            v-else
            label="Bild-URL"
            :vid="vid + '.src'"
            v-model="localModel.src"
            @input="emitChange"
            placeholder="https://examle.com/image.jpg"
        ></input-with-validation>

        <div class="row">
            <div class="col-md-6">
                <input-with-validation
                    label="Max bredd"
                    :vid="vid + '.width'"
                    v-model="localModel.width"
                    @input="emitChange"
                    placeholder="Bredd"
                >
                    <template v-slot:input-group-append>
                        <span class="input-group-text">px</span>
                    </template>
                </input-with-validation>
            </div>
            <div class="col-md-6">
                <input-with-validation
                    label="Alt text"
                    :vid="vid + '.alt'"
                    v-model="localModel.alt"
                    @input="emitChange"
                    placeholder="Alt text"
                ></input-with-validation>
            </div>
        </div>
    </template-block>
</template>

<script>
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import TemplateBlock from '@components/Ecard/TemplateBlock.vue';
import { genUUID } from '@services/Helpers';
import MediabankSelector from '@components/MediabankSelector.vue';

export default {
    name: 'BlockImage',
    components: {
        MediabankSelector,
        TemplateBlock,
        InputWithValidation,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        vid: {
            type: String,
            default: 'image.',
        },
        open: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'normal',
        },
    },
    data: () => ({
        localModel: null,
        useMediabank: true,
    }),
    mounted() {
        this.init(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.init(newVal);
            },
        },
    },
    methods: {
        init(newVal) {
            if (!this.localModel || (newVal.id && newVal.id !== this.localModel.id)) {
                this.useMediabank = newVal.mediaId > 0;
            }
            this.localModel = {
                type: 'image',
                id: newVal.id || genUUID(),
                mediaId: newVal.mediaId || null,
                src: newVal.src === undefined ? '' : (newVal.src || ''),
                alt: newVal.alt || '',
                width: newVal.width ?? '',
                locked: newVal.locked === undefined || newVal.locked === null ? false : newVal.locked,
            };
        },
        changeSource() {
            if (this.useMediabank) {
                this.localModel.src = '';
            } else {
                this.localModel.mediaId = null;
            }
            this.emitChange();
        },
        emitChange() {
            this.$emit('input', { ...this.localModel });
        },
    },
};
</script>
